import { request } from './http';
import type { ResourceRecord } from './resources';

export interface DemoLoginHint {
  username: string;
  password: string;
}

export interface DemoStatus {
  demo: boolean;
  read_only: boolean;
  login_hint?: DemoLoginHint;
}

export const getDemoStatus = () =>
  request<DemoStatus>({
    url: '/api/demo/status',
    method: 'GET',
    timeout: 5_000,
  });

export const listDemoCloudDirectories = (params: {
  cloud_storage_id: number;
  cid?: string;
  offset?: number;
  limit?: number;
}) =>
  request<{
    cloud_storage_id: number;
    cid: string;
    offset: number;
    limit: number;
    total: number;
    items: ResourceRecord[];
  }>({
    url: '/api/demo/cloud-directories',
    method: 'GET',
    params,
  });
